import React from 'react';
import { useNavigate } from 'react-router-dom';
import AutoImageCarousel from './AutoImageCarousel';
import './ServiceCard.css';

const ServiceCard = ({ service, onClick, images }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (service.id) {
      navigate(`/company/${service.id}`);
    }
  };

  const handleCarouselInteraction = (event) => {
    event.stopPropagation();
  };

  return (
    <div onClick={handleClick} className="service-card">
      {/* Service Badges */}
      <div className="service-badges">
        <span className="service-badge">
          {service.service}
        </span>
        {service.badge && (
          <span className="service-badge service-badge-secondary">
            {service.badge}
          </span>
        )}
      </div>

      {/* Content */}
      <div className="service-card-content">
        <h3 className="service-card-title">
          {service.name}
        </h3>
        <p className="service-card-description">
          {service.description}
        </p>

        {images && images.length > 0 && (
          <div
            className="service-card-carousel"
            onClick={handleCarouselInteraction}
            onKeyDown={handleCarouselInteraction}
            role="presentation"
          >
            <AutoImageCarousel images={images} embedded />
          </div>
        )}

        {/* Arrow Icon */}
        <div className="service-card-link">
          <span>Learn More</span>
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
